module.exports = __webpack_public_path__ + "img/banner-consortium-image.ada27f95.webp";